import { createAction, props } from '@ngrx/store';
import { ApiPropertyRegister } from '@foxeet/domain';
import { FEATURE_NAME } from '../domain/utils-chest.config';

const featureTITLE = `[${FEATURE_NAME}] `;

export const setPropertyRegister = createAction(featureTITLE + 'setPropertyRegister');
export const setPropertyRegisterAPI = createAction(featureTITLE + 'setPropertyRegisterAPI', props<{ propertyRegister: ApiPropertyRegister[] }>());
